"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLayout = function (xs) {
    return xs.reduce(function (memo, row, rowIndex) {
        return __assign(__assign({}, memo), row.reduce(function (acc, key, keyIndex) {
            var _a;
            var aboveRow = exports.DEFAULT_KEYMAP[rowIndex - 1];
            var belowRow = exports.DEFAULT_KEYMAP[rowIndex + 1];
            return __assign(__assign({}, acc), (_a = {}, _a[key] = {
                neighbors: [
                    // Above
                    aboveRow && aboveRow[keyIndex],
                    aboveRow && aboveRow[keyIndex + 1],
                    // Left
                    row[keyIndex - 1],
                    // Right
                    row[keyIndex + 1],
                    // Below
                    belowRow && belowRow[keyIndex - 1],
                    belowRow && belowRow[keyIndex]
                ].filter(Boolean)
            }, _a));
        }, {}));
    }, {});
};
exports.DEFAULT_KEYMAP = [
    "1 2 3 4 5 6 7 8 9 0 - =".split(" "),
    "q w e r t y u i o p [ ] \\".split(" "),
    "a s d f g h j k l ; '".split(" "),
    "z x c v b n m , . /".split(" ")
];
exports.SHIFT_KEYMAP = [
    "! @ # $ % ^ & * ( ) _ +".split(" "),
    "Q W E R T Y U I O P { } |".split(" "),
    'A S D F G H J K L : "'.split(" "),
    "Z X C V B N M < > ?".split(" ")
];
exports.LAYOUT = {
    default: exports.buildLayout(exports.DEFAULT_KEYMAP),
    shift: exports.buildLayout(exports.SHIFT_KEYMAP)
};
exports.neighborsOf = function (key) {
    var char = exports.LAYOUT.default[key];
    if (char) {
        return exports.LAYOUT.default[key].neighbors;
    }
    return [];
};
